module.exports = __webpack_public_path__ + "img/freight_yard5_31.0017ed7b.png";